import {
  Dialog,
  IconButton,
  TableCell,
  TableRow,
  Tooltip,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { Delete } from "@mui/icons-material";
import { useState } from "react";
import { Link } from "react-router-dom";
import ConfirmationModal from "../../../../../App/Components/Modals/ConfirmationModal";
import Signifier from "../../../../../App/Components/Signifier/Signifier";
import { callAPI } from "../../../../../App/Helpers/callApi";
import { DeleteLocation, getLocations } from "../../../LocationsService";

const useStyles = makeStyles((theme) => ({
  rowCell: {
    cursor: "pointer",
    background: theme.palette.primary.blue,
    textDecoration: "none",
    "&:hover": {
      background: "rgba(0,0,0,.2) !important",
    },
  },
  rowCellOdd: {
    cursor: "default !important",
    background: "white",
    textDecoration: "none",
    "&:hover": {
      background: "rgba(0,0,0,.2) !important",
    },
  },
  tableCell: {
    color: theme.palette.primary.copy,
  },
}));

export default function LocationsTableCell({
  columns,
  element,
  index,
  setTableData,
}) {
  const classes = useStyles();
  const [deleteModal, setDeleteModal] = useState(false);
  const [showSignifier, setShowSignifier] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");
  const [showError, setShowError] = useState(false);
  const [processing, setProcessing] = useState(false);

  const callDeleteLocation = () => {
    callAPI(
      DeleteLocation(element.id),
      "Location Deleted",
      setShowSignifier,
      setResponseMessage,
      setShowError,
      setProcessing
    ).then(() => {
      getLocations(element.clientId).then((response) => {
        setTableData(response);
      });
    });
  };

  function openModal(e) {
    e.preventDefault();
    setDeleteModal(true);
  }

  return (
    <>
      <Signifier
        showSignifier={showSignifier}
        setShowSignifier={setShowSignifier}
        message={responseMessage}
        error={showError}
      />
      <TableRow
        hover
        className={classes.rowCell}
        key={index}
        component={Link}
        to={{ pathname: "/locations/locationdetailed", state: element }}
        className={index % 2 ? classes.rowCell : classes.rowCellOdd}
      >
        {columns.map((column, elementIndex) => (
          <TableCell
            align="left"
            key={elementIndex}
            className={classes.tableCell}
          >
            {column.label === "City" ? (
              element.address?.city?.name
            ) : column.label === "Division" ? (
              element.address?.city?.division?.name
            ) : column.label === "Zip Code" ? (
              element.address?.zipCode
            ) : column.label === "Delete" &&
              element.adLocationXrefs.length === 0 ? (
              <Tooltip title="Delete Location">
                <IconButton onClick={(e) => openModal(e)} size="large">
                  <Delete />
                </IconButton>
              </Tooltip>
            ) : (
              element[column.propName]
            )}
          </TableCell>
        ))}
      </TableRow>
      <Dialog open={deleteModal} onClose={() => setDeleteModal(false)}>
        <ConfirmationModal
          question="Delete this location?"
          func={() => callDeleteLocation()}
          closeModal={() => setDeleteModal(false)}
        />
      </Dialog>
    </>
  );
}
